import React from "react";
import "../styles/Footer.css";
//import FadeInSection from "./FadeInSection";

function Footer(){
    return(
        <div className="wrapper">
            <div id="footer">
                <div className="ending-footer">
                    <div>Built and designed by Sami Hassan, 2025. </div>
                </div>
            </div>
        </div>
            
        );
    
}

export default Footer;